var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconModuleExperiences(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-module-experiences",
    transform: "translate(-32.022 -0.022)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5839",
    "data-name": "Rectangle 5839",
    width: 92,
    height: 92,
    transform: "translate(32.022 0.022)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-experiences",
    transform: "translate(48.437 19.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2730",
    "data-name": "Group 2730",
    transform: "translate(0 0.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40912",
    "data-name": "Path 40912",
    d: "M2.192,56.762a1.247,1.247,0,0,1-.674-.216,1.164,1.164,0,0,1-.458-.89V8.907a1.149,1.149,0,0,1,.809-1.078l19.573-5.8a1.2,1.2,0,0,1,1,.189,1.164,1.164,0,0,1,.458.89v46.56a1.1,1.1,0,0,1-.782,1.051l-19.6,5.985A1.159,1.159,0,0,1,2.192,56.762ZM3.325,9.743v44.4L20.66,48.836V4.594Z",
    transform: "translate(-1.06 -1.997)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2731",
    "data-name": "Group 2731",
    transform: "translate(36.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40913",
    "data-name": "Path 40913",
    d: "M15.632,56.77a1.247,1.247,0,0,1-.674-.216,1.164,1.164,0,0,1-.458-.89V8.915a1.149,1.149,0,0,1,.809-1.078l19.573-5.8a1.127,1.127,0,0,1,.971.162,1.164,1.164,0,0,1,.458.89v46.56a1.1,1.1,0,0,1-.782,1.051L15.956,56.689A.718.718,0,0,1,15.632,56.77ZM16.738,9.751v44.4l17.335-5.311V4.6Z",
    transform: "translate(-14.5 -1.992)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2732",
    "data-name": "Group 2732",
    transform: "translate(19.6 0.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40914",
    "data-name": "Path 40914",
    d: "M26.1,56.757a1.82,1.82,0,0,1-.377-.054L9.058,50.718a1.113,1.113,0,0,1-.728-1.051V3.106a1.136,1.136,0,0,1,.458-.917,1.239,1.239,0,0,1,1.024-.135l16.661,5.8A1.1,1.1,0,0,1,27.229,8.9V55.652a1.218,1.218,0,0,1-.458.917A1.59,1.59,0,0,1,26.1,56.757ZM10.541,48.885l14.451,5.176V9.684L10.541,4.67Z",
    transform: "translate(-8.33 -2)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleExperiences);
export default __webpack_public_path__ + "static/media/icon-module-experiences.e945d2a8.svg";
export { ForwardRef as ReactComponent };